import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { ContactInformationComponent } from './components/contact-information/contact-information.component';
import { FaqComponentComponent } from './components/faq-component/faq-component.component';
import { ShortcutsComponent } from './components/shortcuts/shortcuts.component';
import { SecuredHomeComponent } from './secured-home.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { MatButtonModule } from '@angular/material/button';
import { AdditonalServicesComponent } from './components/additonal-services/additonal-services.component';
import { AdditionalServiceCardComponent } from './components/additonal-services/components/additional-service-card/additional-service-card.component';
import { MatCardModule } from '@angular/material/card';
import { SolutionsComponent } from './components/solutions/solutions.component';
import { SolutionCardComponent } from './components/solutions/components/solution-card/solution-card.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { CarouselModule } from 'ngx-owl-carousel-o';

const routing = RouterModule.forChild([
  {
    path: '',
    component: SecuredHomeComponent,
  },
]);

const materialModules = [MatSelectModule, MatProgressSpinnerModule, MatIconModule, MatButtonModule, MatCardModule];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    routing,
    PdfViewerModule,
    NgxSkeletonLoaderModule,
    ...materialModules,
    CarouselModule,
  ],
  declarations: [
    SecuredHomeComponent,
    ShortcutsComponent,
    ContactInformationComponent,
    FaqComponentComponent,
    WelcomeComponent,
    AdditonalServicesComponent,
    AdditionalServiceCardComponent,
    SolutionsComponent,
    SolutionCardComponent,
  ],
  exports: [SecuredHomeComponent],
})
export class SecuredHomeModule {}
